import React, { Component } from 'react';
import { Heading, Link, Image, Paragraph, Icon } from 'components';
import { getArticleSlug } from 'config/helpers';
import { ICON_TYPES } from 'config';
import marker from 'assets/images/career/icons/map-marker.svg';
import './SingleOffer.scss';

class SingleOffer extends Component {
  handleCategoryClick = (event, category) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.toggleFilter(category);
  };

  render() {
    const { offer } = this.props;
    const { frontmatter } = offer.node;
    const { title, settings, mainContent } = frontmatter;

    return (
      <Link
        id={title}
        to={getArticleSlug(offer)}
        additionalClass={'offer__container'}
      >
        <Heading type={3} size={'medium'}>
          {mainContent.name}
        </Heading>
        <Paragraph additionalClass={'text--light offer__detail--short'}>
          {settings.category}
        </Paragraph>
        <Paragraph additionalClass={'text--light offer__detail--short'}>
          <Image
            src={marker}
            alt={'location'}
            additionalClass={'offer__marker'}
          />
          {mainContent.city}
        </Paragraph>
        <div>
          <Paragraph additionalClass={'text--light offer__detail--long offer__salary'}>
            {mainContent.salary}
          </Paragraph>
          {mainContent.salary2ndLine && (
            <Paragraph additionalClass={'text--light offer__detail--long offer__salary'}>
              {mainContent.salary2ndLine}
            </Paragraph>
          )}
        </div>
        <Icon icon={ICON_TYPES.RIGHT_ARROW} size={'default'} color={'black'} />
      </Link>
    );
  }
}

export default SingleOffer;
